import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Users from '../components/Users.vue';
import Manufacturers from '../components/ManufacturerList.vue';
import Clients from '../components/ClientList.vue';
import ClientContacts from '../components/ClientContactList.vue';
import NewInventoryItemForm from '../components/NewInventoryForm.vue';
import InventoryList from '../components/InventoryList.vue';
import InventorySummaryForm from '../components/InventorySummaryForm.vue';
import InventoryChargesComponent from '../components/ChargesComponent.vue';
import ClientEditComponent from '../components/ClientEditForm.vue';
import ManufacturerEditForm from '../components/ManufacturerEditForm.vue';
import EditUserComponent from '../components/EditUserComponent.vue';
import RegisterComponent from '../components/RegisterComponent.vue';
import PendingInventoryComponent from '../components/PendingInventoryList.vue';
import PendingInventorySummaryForm from '../components/PendingInventorySummaryForm.vue';
import SettingsComponent from '../components/SettingsComponent.vue';
import MetricsComponent from '../components/MetricsComponent.vue';
import ChangePasswordComponent from '../components/ChangePasswordComponent.vue';
import MasterReportView from '../views/MasterReportView.vue';

import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: 'simple',
    },
    props: true,
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterComponent,
    meta: {
      layout: 'simple',
    },
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/users/:userId',
    name: 'userEdit',
    component: EditUserComponent,
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/manufacturers',
    name: 'manufacturers',
    component: Manufacturers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/manufacturers/:mfgId',
    name: 'mfgEdit',
    component: ManufacturerEditForm,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/clients',
    name: 'clients',
    component: Clients,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/clients/:clientId',
    name: 'clientEdit',
    component: ClientEditComponent,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contacts/:clientId',
    name: 'clientContacts',
    component: ClientContacts,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory',
    name: 'inventoryList',
    component: InventoryList,
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/inventory/pending',
    name: 'pendingInventoryList',
    component: PendingInventoryComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory/pending/:itemId',
    name: 'pendingInventoryEdit',
    component: PendingInventorySummaryForm,
    meta: {
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: '/inventory/new',
    name: 'newInventory',
    component: NewInventoryItemForm,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory/charges',
    name: 'inventoryCharges',
    component: InventoryChargesComponent,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      // The master report used to be a Charge Reports tab; keep shared links working.
      if (to.query.tab === 'master') {
        const { tab, ...query } = to.query;
        next({ name: 'masterReport', query, replace: true });
        return;
      }
      next();
    },
  },
  {
    path: '/reports/master',
    name: 'masterReport',
    component: MasterReportView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/inventory/:itemId',
    name: 'inventoryEdit',
    component: InventorySummaryForm,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    name: 'home',
    component: NewInventoryItemForm,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/metrics',
    name: 'metrics',
    component: MetricsComponent,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: ChangePasswordComponent,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn']) {
      next();
      return;
    }

    next('/login');
  } else {
    next();
  }
});

export default router;
